import { Amplify } from "aws-amplify";
import outputs from "../aws-exports";

/**
 * This class is used for project configuration.
 * It follow a Singleton pattern.
 * @extends Amplify Extends Amplify class
 */
// @ts-ignore
export class Config {
  private static instance: Config;

  /**
   * This static method returns class instance if exist,
   * otherwise it returns a new instance
   */
  public static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }
    return Config.instance;
  }

  /**
   * This method initialize Amplify configuration
   * @example
   * Config.getInstance().init(amplifyConfig)
   */
  // @ts-ignore
  public async init(amplifyConfig, appSyncSettings) {
    try {
      /**
       * We unfornately have to apply this workaround because Webpack performs
       * a static analyse at build time. It doesn't try to infer variables.
       * For more information check this issue: https://github.com/webpack/webpack/issues/6680#issuecomment-370800037
       */
      // const name = "aws-exports";
      // const module = await import(`../${name}`);

      // console.log({
      //   ...outputs,
      //   ...appSyncSettings,
      // });
      Amplify.configure({
        ...outputs,
        ...appSyncSettings,
      });
    } catch (error) {
      console.log("Error loading Amplify configuration:", error);
      // Amplify.configure({ ...amplifyConfig, ...appSyncSettings });
      // Amplify.I18n.setLanguage(amplifyConfig.language || "us");
    }
  }
}
